import { defaultThankYouCard } from './defaultShapes/thankyou';
import { generateFactory } from './generate-factory';
import { generateThankYouCardId } from './generate-ids';

export const generateThankYouCard = generateFactory(
    defaultThankYouCard,
    generateThankYouCardId
);
